import { render, staticRenderFns } from "./HomeExpansionPanels.vue?vue&type=template&id=08680191&scoped=true&"
import script from "./HomeExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./HomeExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./HomeExpansionPanels.vue?vue&type=style&index=0&id=08680191&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08680191",
  null
  
)

export default component.exports